import NOTFOUNDPage from '../components/notfound/404page';
import Layout from '../components/layouts/allpagelayout';
export default function NotFoundPage() {
  return (
    <Layout>
      <NOTFOUNDPage />
    </Layout>
  );
}